module.exports = __webpack_public_path__ + "img/台灣大哥大.0f0a100c.png";